import courseService from "./CourseService";
import { useI18n } from "src/utils/lni18n";
import { useInput } from "src/components/Modalservice/UseInput";


export const useAddTheme = () => {

    const { languageService: t } = useI18n();
    const input = useInput();

    async function addTheme(courseId: string) {

        try {
            const name = await input(t.getText("add.theme"), <div>{t.getText("name")}</div>);
            const trimmedName = (name || "").trim();
            if (trimmedName !== "") {
                await courseService.addTheme(courseId, trimmedName);
                return true;
            }
            return false;
        } catch (e) {
            console.error("Failed to add theme:", e);
            return false;
        }


    }
    return addTheme;

}